module.exports = __webpack_public_path__ + "img/case.aebda82b.svg";